import {EventAppInfo} from '@hconnect/common/types'
import {getEventRoute} from '@hconnect/common/utils'
import {AppLogo} from '@hconnect/uikit'
import {Typography, Paper, Link} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

export const SourceAppInfo = ({app, externalId, plantId}: EventAppInfo) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Paper
      elevation={2}
      component="div"
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 2,
        borderLeft: 6,
        borderLeftColor: theme.palette.secondary.main
      })}
    >
      <Typography component={'span'} variant="body1">
        {t('createdInApp', {appName: app})}
      </Typography>
      <Link
        underline="hover"
        href={getEventRoute({app, externalId, plantId})}
        data-test-id="task-details-source-app-link"
      >
        <Typography sx={{display: 'flex', alignItems: 'center', gap: 1}}>
          <AppLogo name={app} />
          {t('openInApp', {appName: app})}
        </Typography>
      </Link>
    </Paper>
  )
}
